import "./SystemPromptComponent.scss";
import template from "./SystemPromptComponent.html";
import {IComponentOptions} from "angular";
import {PromptType, SystemPrompt} from "../model/SystemPrompt";

export const SystemPromptComponent = "tfSystemPrompt";

export function systemPromptComponent(): IComponentOptions {
    return {
        template,
        bindings: {
            prompt: "<"
        },
        controllerAs: "ctrl",
        controller: SystemPromptComponentController
    };
}

export class SystemPromptComponentController {

    /** @input */
    public readonly prompt: SystemPrompt;

    public get isOpenAccount(): boolean {
        return this.prompt?.type === PromptType.OPEN_ACCOUNT;
    }

    public get isOpenAccountQuiz(): boolean {
        return this.prompt?.type === PromptType.OPEN_ACCOUNT_QUIZ;
    }

    public get isDelayedPrice(): boolean {
        return this.prompt?.type === PromptType.DELAYED;
    }

    public get isTempMessage(): boolean {
        return this.prompt?.type === PromptType.TEMP_MESSAGE;
    }

    public get isTempAndDelayedMessage(): boolean {
        return this.prompt?.type === PromptType.TEMP_AND_DELAYED;
    }

    public get isTrialExpiring(): boolean {
        return this.prompt?.type === PromptType.TRIAL_EXPIRING;
    }

    public get isNoSubscription(): boolean {
        return this.prompt?.type === PromptType.NO_SUBSCRIPTION;
    }
    public get isSwiftReady(): boolean {
        return this.prompt?.type === PromptType.SWIFT_READY;
    }
    public get isSwiftStarted(): boolean {
        return this.prompt?.type === PromptType.SWIFT_STARTED;
    }
    public get isMaintenance(): boolean {
        return this.prompt?.type === PromptType.MAINTENANCE;
    }
}
